<template>
  <div class="pt-result">
    <div class="pt-result__content">
      <p v-if="date" class="pt-result__date">{{ date }}</p>
      <h3 v-if="category && category.section">
        <nuxt-link v-if="title" :to="`/${category.section}/${slug}`" class="pt-result__title mb-4">
          {{ title }}
        </nuxt-link>
      </h3>
      <p v-if="subtitle" class="pt-result__subtitle">{{ subtitle }}</p>
      <p v-if="description" class="pt-result__description">{{ description }}</p>
      <h5 v-if="autor">
        <nuxt-link :to="`${baseUrl}/${slugAutor}`" class="pt-result__autor">
          {{ autor }}
        </nuxt-link>
      </h5>
      <div v-if="category && category.label" class="pt-result__link">
        <!-- <nuxt-link v-if="title" :to="`${baseUrl}/${slug}`" class="pt-result__link"> -->
        {{ category.label }}
        <!-- </nuxt-link> -->
      </div>
    </div>
    <div v-if="image.url" class="pt-result__image">
      <NuxtImg
        :key="image.url"
        :alt="image.alternativeText"
        :title="image.alternativeText"
        :src="image.url"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Results',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    },
    autor: {
      type: String,
      default: ''
    },
    slugAutor: {
      type: String,
      default: ''
    },
    image: {
      type: Object,
      default: () => ({})
    },
    category: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {};
  }
};
</script>
<style src="./style.scss" lang="scss" />
